/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- TRENDING NOW V2 ANALYTICS - PAGE VIEW REPORT : STYLES --------------- ++++++++++ */
export default {
    pageviewreport: {
    }
};
